import { Card, CardBody, Col, Row } from "reactstrap";
import { dynamicAPIImage } from "../../Utils";
import { useQuery } from "@tanstack/react-query";
import {
  InputGroup,
  Input,
  Label,
  FormGroup,
  InputGroupText,
} from "reactstrap";
import { useState, useEffect } from "react";
import { H6, Image, Btn, P } from "../../AbstractElements";
import CommonCardHeader from "../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Link } from "react-router-dom";
import { Edit, Camera } from "react-feather";
import { useNavigate } from "react-router-dom";

//SERVICES
import {
  VIEW_CANDIDATES_QUERY_KEY,
  applicantsService,
} from "../../Services/applicantsService";

//TYPES
import { ViewCandidateProfile } from "../../Types/Applicants/Candidates";

//MODALS
import UploadProfileModal from "../UiKits/Modal/Applicants/UploadProfile";
import UpdateCandidateModal from "../UiKits/Modal/Applicants/UpdateCandidate";
import UpdateAddressModal from "../UiKits/Modal/Applicants/UpdateAddress";

interface CandidateProfileProps {
  ApplNo: string;
}

const CandidateProfile: React.FC<CandidateProfileProps> = ({ ApplNo }) => {
  const [formData, setFormData] = useState<ViewCandidateProfile | null>(null);
  const [modal, setModal] = useState(false);
  const [Candidatemodal, setCandidateModal] = useState(false);
  const [Addressmodal, setAddressModal] = useState(false);
  const toggle = () => setModal(!modal);
  const toggleCandidateModal = () => setCandidateModal(!Candidatemodal);
  const toggleAddressModal = () => setAddressModal(!Addressmodal);
  const navigate = useNavigate();

  const { data: candidateprofileData, isLoading: isFetching } = useQuery({
    queryKey: [VIEW_CANDIDATES_QUERY_KEY, ApplNo],
    queryFn: () => applicantsService.getCandidateProfile(ApplNo),
  });

  useEffect(() => {
    if (candidateprofileData) {
      setFormData(candidateprofileData);
    }
  }, [candidateprofileData]);

  const fullName = [
    formData?.first_name,
    formData?.middle_name,
    formData?.last_name,
    formData?.suffix,
  ]
    .filter(Boolean)
    .join(" ");

  const fullAddress = [
    formData?.address_line1,
    formData?.address_line2,
    formData?.barangay,
    formData?.city,
    formData?.province,
    formData?.country,
    formData?.zip_code,
  ]
    .map((value) => value?.toString().trim())
    .filter(Boolean)
    .join(", ");

  const mobileNo = [formData?.mobile1, formData?.mobile2]
    .map((value) => value?.toString().trim())
    .filter(Boolean)
    .join(" | ");

  if (formData?.emp_no) {
    const encoded = btoa(formData.emp_no.toString());
    navigate(
      `${process.env.PUBLIC_URL}/workforce/employee/${encodeURIComponent(encoded)}`,
    );
  }

  return (
    <Col sm="12">
      {" "}
      {/* START COL */}
      {/* MODALS */}
      <UploadProfileModal ApplNo={ApplNo} modal={modal} toggle={toggle} />
      <UpdateCandidateModal
        ApplNo={ApplNo}
        modal={Candidatemodal}
        toggle={toggleCandidateModal}
      />
      <UpdateAddressModal
        ApplNo={ApplNo}
        modal={Addressmodal}
        toggle={toggleAddressModal}
      />
      {/* END MODALS */}
      {/* HEAHER CARD */}
      <Card className="hovercard text-center user-profile-card">
        <CommonCardHeader
          headClass={`bg-${formData?.status_color || "primary"} d-flex align-items-center pb-3`}
          tagClass="txt-light"
          icon={<i className="icofont icofont-warning-alt me-2"></i>}
          title={formData?.application_status_label || "Loading..."}
        />
        <div className="cardheader"></div>
        <div className="user-image">
          <div className="avatar">
            <Image
              className="img-fluid top-radius-blog"
              src={dynamicAPIImage(formData?.profile_url)}
              alt={formData?.application_no}
              style={{ width: 200, height: 200, objectFit: "cover" }}
            />
            <br></br>
            <div className="icon-wrapper" onClick={toggle}>
              <Camera size={16} />
            </div>
          </div>
        </div>
        <div className="info">
          <Row className="g-3">
            {/* LEFT */}
            <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
              <Row>
                <Col md="7">
                  <div className="ttl-info text-start">
                    <H6 className="mb-1">
                      <i className="fa fa-envelope me-2"></i> Email Address
                    </H6>
                    <span className="mb-2">
                      {isFetching
                        ? "Loading data..."
                        : formData?.email_address
                          ? formData.email_address
                          : "* No Record Found *"}
                    </span>
                  </div>
                </Col>
                <Col md="5">
                  <div className="ttl-info text-start">
                    <H6 className="mb-1">
                      <i className="fa fa-calendar me-2"></i> Date of Birth
                    </H6>
                    <span className="mb-2">
                      {isFetching
                        ? "Loading data..."
                        : formData?.birthdate
                          ? new Date(formData.birthdate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              },
                            )
                          : "* No Record Found *"}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* CENTER */}
            <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
              <div className="user-designation">
                <div className="title">
                  <br></br>
                  <Link to="#">
                    <b>{fullName?.toUpperCase()}</b>
                  </Link>
                </div>
                <P>{formData?.job_title.toUpperCase()}</P>
              </div>
            </Col>
            {/* RIGHT */}
            <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
              <Row>
                <Col md="7">
                  <div className="ttl-info text-start">
                    <H6 className="mb-1">
                      <i className="fa fa-phone me-2"></i> Contact No.
                    </H6>
                    <span className="mb-2">
                      {isFetching
                        ? "Loading data..."
                        : mobileNo
                          ? mobileNo
                          : "* No Record Found *"}
                    </span>
                  </div>
                </Col>
                <Col md="5">
                  <div className="ttl-info text-start">
                    <H6 className="mb-1">
                      <i className="fa fa-location-arrow me-2"></i> Address
                    </H6>
                    <span className="mb-2">
                      {isFetching
                        ? "Loading data..."
                        : fullAddress
                          ? fullAddress
                          : "* No Record Found *"}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Card>
      {/* END HEAHER CARD */}
      {/* START PERSONAL INFORMATION */}
      <Row>
        {/* PERSONAL INFORMATION */}
        <Col sm="12 ">
          <Card className="card-absolute">
            <CommonCardHeader
              headClass="bg-primary"
              tagClass="txt-light"
              icon={<i className="icofont icofont-info-circle me-2"></i>}
              title={"Personal Information"}
            />
            <CardBody>
              <div className="d-flex justify-content-end">
                <Btn color="info" onClick={toggleCandidateModal}>
                  <Edit size={16} className="me-1" />
                  Update Application Details
                </Btn>
              </div>

              {/* Picture */}
              <Row className="mb-3">
                {/* Information */}
                <Col sm="12">
                  <Row>
                    <Col sm="12">
                      <Row>
                        <Col md="3">
                          <FormGroup>
                            <Label>First Name</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-user txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.first_name ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Middle Name</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-user txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.middle_name ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Last Name</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-user txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.last_name ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Suffix Name</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-user txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.suffix || "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Birthdate</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-ui-calendar txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.birthdate
                                      ? new Date(
                                          formData.birthdate,
                                        ).toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "long",
                                          year: "numeric",
                                        })
                                      : "<i>* No Record Found * </i>"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Gender</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-users txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.gender || "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Civil Status</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-heart-alt txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.civil_status ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="3">
                          <FormGroup>
                            <Label>Nationality</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-flag txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.nationality ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <Label>Email Address</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-email txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.email_address ||
                                      "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <FormGroup>
                            <Label>Mobile No.</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-phone txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : mobileNo || "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <FormGroup>
                            <Label>Telephone No.</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-telephone txt-primary"></i>
                              </InputGroupText>
                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : formData?.telno || "* No Record Found *"
                                }
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="12">
                          <FormGroup>
                            <Label>Address</Label>
                            <InputGroup>
                              <InputGroupText>
                                <i className="icofont icofont-location-pin txt-primary"></i>
                              </InputGroupText>

                              <Input
                                disabled
                                value={
                                  isFetching
                                    ? "Loading data..."
                                    : fullAddress || "* No Record Found *"
                                }
                              />
                              <Btn color="info" onClick={toggleAddressModal}>
                                <Edit size={16} className="me-1" />
                                Update Address
                              </Btn>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        {/* START GOVERMENT ID */}
        <Col sm="6">
          <Card className="card-absolute">
            <CommonCardHeader
              icon={<i className="icofont icofont-card me-2"></i>}
              headClass="bg-primary"
              tagClass="txt-light"
              title={"Government IDs"}
            />
            <CardBody>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>TIN</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.tin || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>SSS ID</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.sss_id || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>Pag-IBIG ID</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.pagibig_id || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>PhilHealth ID</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.philhealth_id || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>UMID</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.umid || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>National ID</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-id-card txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.national_id || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        {/* END GOVERMENT ID */}

        {/* START EDUCATION */}
        <Col sm="6">
          <Card className="card-absolute">
            <CommonCardHeader
              icon={<i className="icofont icofont-university me-2"></i>}
              headClass="bg-primary"
              tagClass="txt-light"
              title={"Highest Educational Attainment"}
            />
            <CardBody>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Education</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-hat-alt txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.ed_level || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>Year</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-ui-calendar txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.year || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="3">
                  <FormGroup>
                    <Label>Status</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-tag txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.ed_status || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup>
                    <Label>School</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-university txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.school_name || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>Course / Strand </Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-instrument txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.course || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <Label>Honor</Label>
                    <InputGroup>
                      <InputGroupText>
                        <i className="icofont icofont-certificate-alt-1 txt-primary"></i>
                      </InputGroupText>
                      <Input
                        disabled
                        value={
                          isFetching
                            ? "Loading data..."
                            : formData?.honor || "* No Record Found *"
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        {/* START EDUCATION */}
      </Row>
    </Col> //END COLS
  );
};

export default CandidateProfile;
